export default {
  TRIP: {
    STATUS: {
      OPEN: 0,
      CLOSED: 1,
    },
    CONTROL_TYPE: {
      KM: 'km',
      ENTRY: 'entry',
    },
    APPROVAL: [
      { status: 'OPEN', key: 0, label: 'EM ABERTO' },
      { status: 'ACCEPTED', key: 1, label: 'ACEITO' },
      { status: 'DECLINED', key: 2, label: 'DECLINADO' },
    ],
    GROUP_OPTIONS: [
      { key: 'car', value: 'Agrupando por: Carro' },
      { key: 'employee', value: 'Agrupando por: Motorista' },
    ],
    OCCURRENCES: {
      STOP_DELAYED: { status: 'STOP_DELAYED', key: 0, label: 'Atrasado' },
      STOP_ADVANCED: { status: 'STOP_ADVANCED', key: 1, label: 'Adiantado' },
      STOP_ON_TIME: { status: 'STOP_ON_TIME', key: 2, label: 'Correto' },
      STOP_NO_STOP: { status: 'STOP_NO_STOP', key: 3, label: 'Não Parou' },
      ROUTE_AWAY: { status: 'ROUTE_AWAY', key: 4, label: 'Desvio de Rota' },
    },
    METRICS: {
      IPK: { status: 'IPK', key: 0, label: 'IPK' },
      IPKE: { status: 'IPKE', key: 1, label: 'IPKE' },
      REGULARITY: { status: 'REGULARITY', key: 2, label: 'Regularidade' },
      PUNCTUALITY: { status: 'PUNCTUALITY', key: 3, label: 'Pontualidade' },
      AVG_SPEED: { status: 'AVG_SPEED', key: 4, label: 'Média de Velocidade' },
      VALUE_PER_KM: { status: 'VALUE_PER_KM', key: 5, label: 'R$ por KM' },
    },
  },
};
